import React, { useEffect, useState } from 'react';
import StaffLayout from '../../layouts/StaffLayout';
import { Box, Typography, Paper, List, ListItem, ListItemText, Button, Divider, CircularProgress, IconButton } from '@mui/material';
import api from '../../services/api';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNotifications } from '../../context/NotificationContext';

function Notifications() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { notifications, unreadCount, markAsRead, refresh } = useNotifications();

  const markAllRead = async () => {
    try {
      await api.patch('/api/notifications/mark-all-read');
      // refresh provider state
      await refresh();
    } catch {}
  };

  useEffect(() => {
    setLoading(false);
  }, [notifications]);

  if (loading) return (
    <StaffLayout>
      <Box sx={{ p: 3 }}><CircularProgress /></Box>
    </StaffLayout>
  );

  return (
    <StaffLayout>
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h4" fontWeight={700}>Notifications</Typography>
          <Box>
            <IconButton onClick={() => refresh()} aria-label="refresh"><RefreshIcon /></IconButton>
            <Button variant="contained" onClick={markAllRead} sx={{ ml: 1 }}>Mark all read</Button>
          </Box>
        </Box>
        {error && <Typography color="error">{error}</Typography>}
        <Paper>
          <List>
            {(!notifications || notifications.length === 0) ? (
              <ListItem><ListItemText primary="No notifications" /></ListItem>
            ) : notifications.map(note => (
              <React.Fragment key={note._id || note.id}>
                <ListItem sx={{ bgcolor: note.unread ? 'rgba(25,118,210,0.06)' : undefined }}>
                  <ListItemText primary={note.content || note.text} secondary={note.type ? `Type: ${note.type}` : undefined} />
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    {note.relatedLink && <Button size="small" onClick={() => window.open(note.relatedLink, '_blank')}>View</Button>}
                    {note.unread && <Button size="small" onClick={() => markAsRead(note._id)}>Mark read</Button>}
                  </Box>
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </Paper>
      </Box>
    </StaffLayout>
  );
}

export default Notifications;
